import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { useState } from "react";
import { observer } from "mobx-react";
import { TemplateCenter, useTemplateCenterProvider } from "@devowl-wp/react-cookie-banner-admin";
import { useStores } from "../../../store";
import { ConfigContent } from "../content";
import { useLocationQuery } from "../../../hooks";
import { BlockerEditForm } from ".";
const BlockerTemplateCenter = observer(()=>{
    const { cookieStore, optionStore: { isTcf } } = useStores();
    const [fetched, setFetched] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState();
    // Allow to force a template by query argument so the template center is disabled
    const { force, comingFromServiceCreation, attributes: queryAttributes, navigateAfterCreation = true } = useLocationQuery();
    const fetchTemplates = useCallback(async ()=>{
        if (!fetched) {
            setFetched(true);
            await cookieStore.fetchTemplatesBlocker();
        }
        const result = Array.from(cookieStore.templatesBlocker.values()).map((param)=>{
            let { data } = param;
            return data;
        });
        result.sort((a, b)=>a.headline.localeCompare(b.headline));
        return result;
    }, [
        fetched
    ]);
    const [TemplateCenterContextProvider, templateCenterContextValue] = useTemplateCenterProvider({
        type: "content-blocker",
        quickLinks: [
            "blocker-individual",
            "service-scanner",
            "cookie-experts"
        ],
        enableLocalFilter: true,
        syncTemplates: ()=>{
            return cookieStore.fetchTemplatesBlocker({
                storage: "redownload"
            });
        },
        fetchTemplates,
        fetchUse: async (identifier)=>{
            // We do currently not have a "pagination", just load all
            await fetchTemplates();
            return cookieStore.templatesBlocker.get(identifier).fetchUse();
        },
        initialSelection: force,
        onSelect: (template, initialSelection)=>{
            if ((template == null ? void 0 : template.tcfVendorIds.length) > 0 && !isTcf) {
                window.location.href = `#/settings/tcf?tcfIntegrationItem=${encodeURIComponent(template.name)}&navigateAfterTcfActivation=${encodeURIComponent(`#/blocker/new?force=${template.identifier}`)}`;
            } else {
                setSelectedTemplate({
                    identifier: template == null ? void 0 : template.identifier,
                    version: template == null ? void 0 : template.version,
                    overwriteAttributes: initialSelection && queryAttributes ? JSON.parse(queryAttributes) : undefined
                });
            }
        }
    }, {});
    return selectedTemplate === undefined ? /*#__PURE__*/ _jsx(ConfigContent, {
        children: /*#__PURE__*/ _jsx(TemplateCenterContextProvider, {
            value: templateCenterContextValue,
            children: /*#__PURE__*/ _jsx(TemplateCenter, {})
        })
    }) : /*#__PURE__*/ _jsx(ConfigContent, {
        maxWidth: "fixed",
        children: /*#__PURE__*/ _jsx(BlockerEditForm, {
            comingFromServiceCreation: comingFromServiceCreation === "1",
            template: selectedTemplate.identifier ? {
                identifier: selectedTemplate.identifier,
                version: selectedTemplate.version
            } : undefined,
            overwriteAttributes: selectedTemplate.overwriteAttributes,
            navigateAfterCreation: navigateAfterCreation
        })
    });
});
export { BlockerTemplateCenter };
